(() => {
	const initSlider = () => {
		const sections = document.querySelectorAll('.brand-list');

		sections.forEach((el) => {
			const slides = el.querySelectorAll('.swiper-slide');
			// Skip initialization if no valid slides
			if (!slides || slides.length === 0) return;

			const speed1 = el.getAttribute('data-duration') * 1000;
			// Only enable loop if we have enough slides
			const enableLoop = slides.length > 6;

			new Swiper(el, {
				slidesPerView: 2,
				autoplay: enableLoop ? {
					delay: 0,
					disableOnInteraction: false,
				} : false,
				allowTouchMove: false,
				loop: enableLoop,
				speed: speed1,
				breakpoints: {
					750: {
						slidesPerView: 3,
					},
					990: {
						slidesPerView: 4,
					},
					1200: {
						slidesPerView: 6,
					},
				},
			})
		})
	}

	document.addEventListener('DOMContentLoaded', function () {
		initSlider()

		document.addEventListener('shopify:section:load', function () {
			initSlider()
		})
	})
})()
